<script setup>
import {usePortalContentAndDesignStore} from "../../../../../../stores/partners/portalContentAndDesignStore";
import EditableResourceImageField
    from "../../../../portal-editable-fields/resources/EditableResourceImageField.vue";
import EditableTextField from "../../../../portal-editable-fields/EditableTextField.vue";
import EditableResourceTextEditorField
    from "../../../../portal-editable-fields/resources/EditableResourceTextEditorField.vue";
import {ref} from "vue";

const props = defineProps({
    resource: {
        type: Object,
        required: true,
    },
});

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const hoverMainContentLinkContainer = ref(false);
</script>

<template>
    <div>
        <div class="flex justify-start items-center gap-6"
             @mouseenter="hoverMainContentLinkContainer = true"
             @mouseleave="hoverMainContentLinkContainer = false"
             :id="resource.unique_id"
        >
            <editable-resource-image-field
                resource-image-path="main_image"
                :resource-content="resource"
                :img-class="resource.main_image_retina_resize ? 'max-w-8' : 'flex-1 max-w-16'"
                img-name="main_image"
                :show-add-image-button="hoverMainContentLinkContainer"
            />

            <div class="space-y-2">
                <editable-text-field
                    text-type="custom"
                    :class="['text-lg md:text-2xl font-semibold', portalContentAndDesignStore.getPageContentTextColorClass]"
                    v-model="resource.title"
                />
                <editable-resource-text-editor-field
                    :class="[
                        'partnero-page-content-section text-md md:text-lg text-opacity-80 space-y-1',
                        portalContentAndDesignStore.getPageContentTextColorClass
                    ]"
                    :resource="resource"
                    resource-field="description"
                />
            </div>
        </div>

        <div :class="(resource.title || resource.description) ? 'mt-4 md:mt-6' : ''">
            <div
                v-for="(content, index) in resource.contents"
                :key="index"
                class="divide-y"
            >
                <editable-text-field
                    class="py-2 md:py-4 group block"
                    text-type="a"
                    v-model="content.title"
                    link-target="_blank"
                    :href="content.url"
                >
                    <template #custom-content>
                        <div class="flex items-center space-x-5">
                            <icon name="external-link" />
                            <div class="flex-1 group-hover:underline">
                                {{ content.title }}
                            </div>
                        </div>
                    </template>
                </editable-text-field>
            </div>
        </div>
    </div>
</template>
